import React from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

export default function Nineth() {
    const options = {
        loop: true,
        margin: 10,
        nav: false, // Ok işaretlerini gizlemek için nav'ı false yapıyoruz
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 2
          },
          1000: {
            items: 3
          }
        }
      };

      const testimonials = [
        {
          id: 1,
          title: "Revolutionized Our Operations",
          text: "Cornleth has completely transformed how we manage bookings. The dashboard is user-friendly and efficient, allowing us to search and book hotels and tours effortlessly. The reporting tools have been a game-changer for our business growth.",
          name: "Alex Thompson",
          location: "London, United Kingdom",
          image: "/assets/img/person.jpg",
          rating: 5.0
        },
        {
          id: 2,
          title: "Seamless Booking Experience",
          text: "As an independent traveler, I found Cornleth incredibly easy to use. I booked my dream hotel within minutes and had a stress-free experience. This platform is a must-have for anyone looking for fast and reliable bookings.",
          name: "Sarah Patel",
          location: "Sydney, Australia",
          image: "/assets/img/person.jpg",
          rating: 5.0
        },
        {
          id: 3,
          title: "The Ultimate Agency Tool",
          text: "Cornleth’s B2B dashboard has streamlined our workflow like never before. The seamless integration with API data and the detailed reporting features save us countless hours every week. It’s an indispensable tool for any tour operator.",
          name: "John Carter",
          location: "Toronto, Canada",
          image: "/assets/img/person.jpg",
          rating: 5.0
        }
      ];
return (
<>
    <section className="section testimonial-section">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-10 wow fadeInUp text-center" data-wow-delay="0.2s">
                    <div className="section-header text-center">
                        <h2 className="mb-2">What’s Our <span className="text-primary text-decoration-underline">User</span>
                            Says</h2>
                        <p className="sub-title">DreamsTour, a tour operator specializing in dream destinations, offers a
                            variety of benefits for travelers.</p>
                    </div>
                </div>
            </div>
            <OwlCarousel className="owl-carousel testimonial-slider" {...options}>
            {testimonials.map((testimonial) => (
                <div key={testimonial.id} className="card wow fadeInUp border-white" data-wow-delay="0.2s">
                <div className="card-body">
                    <h6 className="mb-4">{testimonial.title}</h6>
                    <p className="mb-4">{testimonial.text}</p>
                    <div className="border-top d-flex align-items-center justify-content-between pt-4">
                    <div className="d-flex align-items-center">
                        <a href="javascript:void(0);" className="avatar avatar-md flex-shrink-0">
                        <img src={testimonial.image} className="rounded-circle" alt="img" onContextMenu={(e) => e.preventDefault()} onDragStart={(e) => e.preventDefault()} />
                        </a>
                        <div className="ms-2">
                        <h6 className="fs-16 fw-medium">
                            <a href="javascript:void(0);">{testimonial.name}</a>
                        </h6>
                        <p>{testimonial.location}</p>
                        </div>
                    </div>
                    <span className="badge badge-warning badge-xs text-gray-9 fs-13 fw-medium me-2">
                        {testimonial.rating}
                    </span>
                    </div>
                </div>
                </div>
            ))}
            </OwlCarousel>
        </div>
        <div className="testimonial-bg">
                            <img src="assets/img/bg/testimonial-bg-01.svg" alt="img" onContextMenu={(e) => e.preventDefault()} onDragStart={(e) => e.preventDefault()}/>
        </div>
    </section>
</>
)
}
